import React from 'react';
import AdminLinksComponent from '../../components/admin/AdminLinks';

const AdminLinks = () => {
  return (
    <div className="container mx-auto px-4 py-6">
      <AdminLinksComponent />
    </div>
  );
};

export default AdminLinks;